/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { login, logoff,loadUserFromStorage } from "_services/oauth";
import axios from "utils/httpClient";
import { authHeader } from "_helpers";
import store from "store";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import Slider from "@material-ui/core/Slider";

import Datetime from 'react-datetime';
import Select from 'react-select';
// core components
import Grid from "components/Grid/GridContainer";
import Col from "components/Grid/GridItem";

import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
// import CardAvatar from "components/Card/CardAvatar.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import TSUser from "components/Forms/TSUser"; 
import TSSelect2 from "components/Forms/TSSelect2";
import TSSelectMultiple from "components/Forms/TSSelectMultiple";
import TSText from "components/Forms/TSText";
import TSRadio from "components/Forms/TSRadio";
import { Collapse, Modal, ModalBody } from "reactstrap";
// import avatar from "assets/img/faces/marc.jpg";
import {
  Input,
  Label,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
} from "reactstrap";

import "react-datetime/css/react-datetime.css"
import "./custom-style.css";
import Meeting from "layouts/HR";
import { Phone } from "@material-ui/icons";


const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    // fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    fontFamily: '"Sarabun", sans-serif',
    marginBottom: "3px",
    textDecoration: "none"
  },
};

const primaryColor = "#af2cc5";

const useStyles = makeStyles(styles);

const Request = (props) => {

  const _meetingID = (props.match.params.MeetingID !== undefined) ? props.match.params.MeetingID : null;

  const { location, ...other } = props;
  const user = useSelector((state) => state.auth.user);
  const history = useHistory();

  var moment = require('moment');
  require('moment/locale/th');
  const [MeetingKey, setMeetingKey] = useState(null);
  const [MeetingID, setMeetingID] = useState('');
  const [MeetingTypeKey, setMeetingTypeKey] = useState(null);
  const [DepartmentKey, setDepartmentKey] = useState(null);
  const [TeamName, setTeamName] = useState('');
  const [MeetingName, setMeetingName] = useState("");

  const [CreatorName, setCreatorName] = useState("");
  const [EditerName, setEditerName] = useState("");
  const [CancelerName, setCancelerName] = useState("");

  const [MeetingDescription, setMeetingDescription] = useState('');

  const [MeetingStatusKey, setMeetingStatusKey] = useState(null);
  const [RoomKey, setRoomKey] = useState(null);
  const [RoomOther, setRoomOther] = useState('');
  const [RoomStyleKey, setRoomStyleKey] = useState(null);
  const [RoomStyleOther, setRoomStyleOther] = useState('');

  const [StartDatetime, setStartDatetime] = useState('');
  const [EndDatetime, setEndDatetime] = useState('');

  const [RoomTotalSeat, setRoomTotalSeat] = useState(0);

  

  const [StartTme, setStartTime] = useState('');
  const [EndTime, setEndTime] = useState('');



  const [CreateDatetime, setCreateDatetime] = useState('');
  const [LastEditDatetime, setLastEditDatetime] = useState('');
  const [CancelDatetime, setCancelDatetime] = useState('');


  const [ContactPhone, setContactPhone] = useState('');

  const [AssetKey, setAssetKey] = useState([]);
  const [Attendee, setAttendee] = useState([]);

  const [TeamGroupTypeKey, setTeamGroupTypeKey] = useState(null);
  const [TeamGroupKey, setTeamGroupKey] = useState(null);

  const [ArrAsset, setArrAsset] = useState([]);
  const [ArrRoom, setArrRoom] = useState([]);
  const [ArrRoomStyle, setArrRoomStyle] = useState([]);

  const [ArrTeamGroup, setArrTeamGroup] = useState([]);
  const [ArrTeamGroupType, setArrTeamGroupType] = useState([]);


  const [modalHoliday, setModalHoliday] = useState(false);
  const [holidayText, setHolidayText] = useState('');
  const [currentDate, setcurrentDate] = useState(moment());
  const [holidays, setHolidays] = useState([]);


  const [modal, setModal] = useState(false);
  const [modalCancel, setModalCancel] = useState(false);
  const [modal2, setModal2] = useState(false);
  const [modal3, setModal3] = useState(false);
  const [modal4, setModal4] = useState(false);
  const [errMsg, setErrMsg] = useState([]);
  const [modalError, setModalError] = useState(false);
  const [icon, setIcon] = useState("far fa-question-circle");
  const [icon2, setIcon2] = useState("far fa-question-circle");

  const [isOpen, setIsOpen] = useState(false);

  const [isEdit, setIsEdit] = useState(false);

  const [dateFocus, setDateFocus] = useState(false);

  const urgentList = [{ label:"ปกติ", value:0}, { label:"ด่วน", value:1} , { label:"ฉุกเฉิน", value:2}];
  const arrMeetingType = [{ label:"จองห้องประชุม", value:1}, { label:"จองรถ", value:2}];

  const arrTime = [
    { label:"7:00 น.", value:'07:00', isDisabled: false},
    { label:"7:30 น.", value:'07:30', isDisabled: false},
    { label:"8:00 น.", value:'08:00', isDisabled: false},
    { label:"8:30 น.", value:'08:30', isDisabled: false},
    { label:"9:00 น.", value:'09:00', isDisabled: false},
    { label:"9:30 น.", value:'09:30', isDisabled: false},
    { label:"10:00 น.", value:'10:00', isDisabled: false},
    { label:"10:30 น.", value:'10:30', isDisabled: false},
    { label:"11:00 น.", value:'11:00', isDisabled: false},
    { label:"11:30 น.", value:'11:30', isDisabled: false},
    { label:"12:00 น.", value:'12:00', isDisabled: false},
    { label:"12:30 น.", value:'12:30', isDisabled: false},
    { label:"13:00 น.", value:'13:00', isDisabled: false},
    { label:"13:30 น.", value:'13:30', isDisabled: false},
    { label:"14:00 น.", value:'14:00', isDisabled: false},
    { label:"14:30 น.", value:'14:30', isDisabled: false},
    { label:"15:00 น.", value:'15:00', isDisabled: false},
    { label:"15:30 น.", value:'15:30', isDisabled: false},
    { label:"16:00 น.", value:'16:00', isDisabled: false},
    { label:"16:30 น.", value:'16:30', isDisabled: false},
    { label:"17:00 น.", value:'17:00', isDisabled: false},
    { label:"17:30 น.", value:'17:30', isDisabled: false},
    { label:"18:00 น.", value:'18:00', isDisabled: false},
    { label:"18:30 น.", value:'18:30', isDisabled: false},
    { label:"19:00 น.", value:'19:00', isDisabled: false},
    { label:"19:30 น.", value:'19:30', isDisabled: false},
    { label:"20:00 น.", value:'20:00', isDisabled: false},
    { label:"20:30 น.", value:'20:30', isDisabled: false}
];

const arrTime2 = [
  { label:"07:30 น.", value:'07:30', isDisabled: false},
  { label:"8:00 น.", value:'08:00', isDisabled: false},
  { label:"8:30 น.", value:'08:30', isDisabled: false},
  { label:"9:00 น.", value:'09:00', isDisabled: false},
  { label:"9:30 น.", value:'09:30', isDisabled: false},
  { label:"10:00 น.", value:'10:00', isDisabled: false},
  { label:"10:30 น.", value:'10:30', isDisabled: false},
  { label:"11:00 น.", value:'11:00', isDisabled: false},
  { label:"11:30 น.", value:'11:30', isDisabled: false},
  { label:"12:00 น.", value:'12:00', isDisabled: false},
  { label:"12:30 น.", value:'12:30', isDisabled: false},
  { label:"13:00 น.", value:'13:00', isDisabled: false},
  { label:"13:30 น.", value:'13:30', isDisabled: false},
  { label:"14:00 น.", value:'14:00', isDisabled: false},
  { label:"14:30 น.", value:'14:30', isDisabled: false},
  { label:"15:00 น.", value:'15:00', isDisabled: false},
  { label:"15:30 น.", value:'15:30', isDisabled: false},
  { label:"16:00 น.", value:'16:00', isDisabled: false},
  { label:"16:30 น.", value:'16:30', isDisabled: false},
  { label:"17:00 น.", value:'17:00', isDisabled: false},
  { label:"17:30 น.", value:'17:30', isDisabled: false},
  { label:"18:00 น.", value:'18:00', isDisabled: false},
  { label:"18:30 น.", value:'18:30', isDisabled: false},
  { label:"19:00 น.", value:'19:00', isDisabled: false},
  { label:"19:30 น.", value:'19:30', isDisabled: false},
  { label:"20:00 น.", value:'20:00', isDisabled: false},
  { label:"20:30 น.", value:'20:30', isDisabled: false},
  { label:"21:00 น.", value:'21:00', isDisabled: false}
];

const [ArrStartTime, setArrStartTime] = useState(arrTime);
const [ArrStopTime, setArrStopTime] = useState(arrTime2);

  const dateTypeList = [{ label:"ทั้งวัน", value:0}, { label:"ครึ่งวันเช้า", value:1} , { label:"ครึ่งวันบ่าย", value:2}];

  const myRef = useRef(null);



  var token = localStorage.getItem("token");


  useEffect(() => {


      if (_meetingID != null && _meetingID != '') {
          props.history.push({
              pathname: '/meeting/request',
              state: {
                  meetingID: _meetingID
              }
          })
      }


    axios("/api/v1/meeting/room")
    .then(
      result => {
            var json = JSON.parse(JSON.stringify(result.data.data).split('"name":').join('"label":').split('"roomKey":').join('"value":'));
            setArrRoom(json)
        }, error => { console.log(error); }
    );  

      axios("/api/v1/meeting/style")
    .then(
      result => {
        var json = JSON.parse(JSON.stringify(result.data.data).split('"name":').join('"label":').split('"roomStyleKey":').join('"value":'));
        setArrRoomStyle(json)
      }, error => {console.log(error);}
    );  

      axios("/api/v1/meeting/asset")
    .then(
      result => {
        var json = JSON.parse(JSON.stringify(result.data.data).split('"name":').join('"label":').split('"assetKey":').join('"value":'));
        setArrAsset(json)
      }, error => {console.log(error);}
    );  

      axios("/api/v1/teamgrouptype")
    .then(
      result => {
        var json = JSON.parse(JSON.stringify(result.data.data).split('"name":').join('"label":').split('"teamGroupTypeKey":').join('"value":'));
        setArrTeamGroupType(json)
      }, error => {console.log(error);}
    );  


    if(location.state != null)
    {
      if(location.state.meetingID != null && location.state.meetingID != '')
      {
        setIsEdit(true)

        //.then(response => response.json())

        axios({
          method: 'get',
            url: "/api/v1/meeting/" + location.state.meetingID,
            headers: { 'referpage': '/meeting/request/'+ location.state.meetingID }
        })
        .then(
            resEdit => {
              var res=resEdit.data.data;
              //console.log(resEdit)
              setMeetingID(res.meetingID)
              setMeetingName(res.meetingName)
              setStartDatetime(moment(res.startDatetime).format('YYYY-MM-DD').toString())
              setEndDatetime(moment(res.endDatetime).format('YYYY-MM-DD').toString())
              setStartTime(moment(res.startDatetime).format('HH:mm'))
              setEndTime(moment(res.endDatetime).format('HH:mm'))  
              setRoomKey(res.roomKey)
              setRoomStyleKey(res.roomStyleKey)
              setRoomTotalSeat(res.roomTotalSeat != null ? res.roomTotalSeat : 0)
              setMeetingDescription(res.meetingDescription)
              setContactPhone(res.contactPhone)

              setCreatorName(resEdit.data.creatorName);
              setEditerName(resEdit.data.editerName);
              setCancelerName(resEdit.data.cancelerName);

              setCreateDatetime(res.createDatetime);
              setLastEditDatetime(res.lastEditDatetime);
              setCancelDatetime(res.cancelDatetime);

              
              var _rAsset = [];
              res.meetingDataRoomAsset.map((row) => (

                _rAsset.push({value: row.assetKey, label: row.meetingRoomAsset.name})

              ));
              setAssetKey(_rAsset)

                /*
                 var _rAttendee = [];
                 res.meetingDataAttendee.map((row) => (
                   _rAttendee.push(row.userView)
                 ));
                 */
                const _rAttendee = res.meetingDataAttendee.map(row => {
                    row.userView['attendStatusKey'] = (row.attendStatusKey != null) ? row.attendStatusKey : 0;
                    return row.userView;
                });
              setAttendee(_rAttendee)
              
            },
            error => {

            }
        );  

      }
      else{
        setRoomKey(location.state.roomKey)
        setMeetingName(location.state.meetingName)
        setStartDatetime(moment(location.state.startDatetime).format('YYYY-MM-DD').toString())
        setEndDatetime(moment(location.state.stopDatetime).format('YYYY-MM-DD').toString())
        setStartTime(moment(location.state.startDatetime).format('HH:mm'))
        setEndTime(moment(location.state.stopDatetime).format('HH:mm'))  
      }
    }
    else{
      
    }

    

  }, [/*token*/]);

  const handleSubmit = evt => {
    evt.preventDefault();
    var cntErr = 0;

    var errMsg = [];

    if(MeetingName == '')
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุชื่อการประชุม"}</li>);
    }
      

    if(StartDatetime == '')
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุวันที่ประชุม"}</li>);
    }

    if(StartTme == '')
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุเวลาเริ่มต้น"}</li>);
    }
      
    if(EndTime == '')
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุเวลาสิ้นสุด"}</li>);
    }
         
    if(RoomKey == null || RoomKey =='')
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุห้องประชุม"}</li>);
    }
               
    if(RoomStyleKey == null || RoomStyleKey =='')
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุรูปแบบการจัดห้องประชุม"}</li>);
    }
            
    if(ContactPhone == '')
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุหมายเลขโทรศัพท์"}</li>);
    }

    if(Attendee == null || Attendee.length == 0)
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุผู้เข้าร่วม"}</li>);
    }
      


    
    if (cntErr > 0) {
      setErrMsg(errMsg);
      setModalError(true);
    } else {
      setModal(true);
    }

  /*
    if (name === null || name === "") {
      cntErr += 1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุชื่อตัวชี้วัด"}</li>);
    }

    if (cntErr > 0) {
      setErrMsg(errMsg);
      setModalError(true);
    } else {
      setModal(true);
    }
  */
  };

  const handleCancel = evt => {
    evt.preventDefault();
    setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");



    axios.put('/api/v1/meeting/cancel/' + MeetingID, null)
          .then(
              result => {
 
                  if (result.data.result == 200) {
                      setIcon("far fa-question-circle");
                      setModalCancel(false)
                      setModal2(true)
                  }
                  else {
                      setIcon("far fa-question-circle");
                      setModalCancel(false)
                      setErrMsg(result.data.msg)
                      setModalError(true)
                  }

              },
              error => { console.log(error); }
    );  

  };

  const handleConfirm = evt => {
    evt.preventDefault();
    setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");


    const _atd = [];
    Attendee.map((row) => (
      _atd.push({ userName : row.userName})
    ));

    const _asset = [];
    AssetKey.map((row) => (
      _asset.push({ assetKey : row.value, note : row.code})
    ));
    
    var meet = {
      //meetingID:3fa85f64-5717-4562-b3fc-2c963f66afa6,
      meetingTypeKey: 1,
      teamGroupTypeKey: 1,
      //teamGroupKey: 0,
      //departmentKey: 0,
      //teamName:string,
      meetingName: MeetingName,
      meetingDescription: MeetingDescription,
      meetingStatusKey: 0,
      roomKey: RoomKey,
      //roomOther:string,
      roomStyleKey: RoomStyleKey,
      roomTotalSeat: RoomTotalSeat,
      //roomStyleOther:string,
      startDatetime: StartDatetime + ' ' + StartTme,
      endDatetime:EndDatetime + ' ' + EndTime,
      contactPhone: ContactPhone,
      //approveCode:string,
      //approveDatetime:2023-03-06T18:44:22.469Z,
      creatorCode: ' ton900',
      meetingDataAttendee : _atd,
    /*
      meetingDataAttendee: [
         {
          //meetingDataAttendeeKey: 0,
          //meetingID:3fa85f64-5717-4562-b3fc-2c963f66afa6,
          userName:'string',
          attendStatusKey: 0,
          //startDatetime:2023-03-06T18:44:22.469Z,
          //endDatetime:2023-03-06T18:44:22.469Z,
          //standinUserName:string,
         }
       ],
*/
      meetingDataRoomAsset: _asset//
         //{
          //meetingDataRoomAssetKey: 0,
          //meetingID:3fa85f64-5717-4562-b3fc-2c963f66afa6,
          //assetKey: 0,
          //note:'string',
         //}
       //],
     }
     //console.log(meet) 



      //แก้ไข
      if(location.state != null && location.state.meetingID != null && location.state.meetingID != '')
      {

        // (url,body)
        axios.put('/api/v1/meeting/'+MeetingID, meet)
        .then(
          result => {
            
            //console.log(result)

            if(result.data.result == 200)
            {
              setIcon("far fa-question-circle"); 
              setModal(false) 
              setModal2(true)
            }
            else
            {
              setIcon("far fa-question-circle"); 
              setModal(false) 
              setErrMsg(result.data.msg)
              setModalError(true) 
            }
  
          },
          error => {console.log(error);}
        );  


      }
      else{
        //ลงทะเบียนใหม่
        axios("/api/v1/meeting", {
          method: 'POST',
          data: meet,
          headers: authHeader()
        })
        .then(response => response.data)
        .then(
            result => {
              
              if(result.result == 200)
              {
                setMeetingID(result.data.meetingID)
                setIcon("far fa-question-circle"); 
                setModal(false) 
                setModal2(true)
              }
              else
              {
                setIcon("far fa-question-circle"); 
                setModal(false) 
                setErrMsg(result.msg)
                setModalError(true)    
              }
    
            },
            error => {console.log(error);}
          );  
      }




    

     









  };



  const GotoEdit = evt => {
      evt.preventDefault();

      if (location.state != null && location.state.meetingID != null && location.state.meetingID != '') {
          setModal2(false)
      }
      else {
         
          props.history.push({ pathname: '/meeting/id/' + MeetingID })
      }

  };




  const handleTeamGroup = (_val) => {
   
    setTeamGroupTypeKey(_val) 

    setArrTeamGroup([]);
    setTeamGroupKey(null);

    if(_val == 2 || _val==3)
    {

      axios("/api/v1/teamgroup/"+_val, {method: "GET"})
      .then(response => response.data)
      .then(
          result => {

            var json = JSON.parse(JSON.stringify(result.data).split('"name":').join('"label":').split('"teamGroupKey":').join('"value":'));
            setArrTeamGroup(json)
            //setArrUserLevel(result.data)
          },
          error => {alert(error);}
      ); 

    }
  };
  const handleAttendee = (_val) => {
    setAttendee(_val);
    setRoomTotalSeat(_val.length);
  };

    const handleStartTime = (_val) => {
      setStartTime(_val);

      if (arrTime != null) {
        const val = arrTime2.filter(e => moment('2023-01-01 ' + e.value) > moment('2023-01-01 ' +_val))
        setArrStopTime(val);
        //console.log(val)
      }
    };
  
    const test = e => {
        myRef.current.scrollIntoView()
    };

    const handleStartDate = (date) => {
      setStartDatetime(date);
      setEndDatetime(date);




  }
    const handleEndDate = (date) => {
    setEndDatetime(date);




}

    const fetchHoliday = (yearMonth) => {

  };

  const handleCurrentDate = (dayAmt, unit) => {
      var curr = moment(currentDate).add(dayAmt, unit)
      setcurrentDate(curr);
      fetchHoliday(curr.format('YYYY/M'));
      return false;
  }

  const handleNavigate = (nextView, currentView, currDate) => {
      if (nextView == 'days') {
          setcurrentDate(currDate);
          fetchHoliday(currDate.format('YYYY/M'));
      }
      return nextView;
  }

  const handleHoliday = (txt) => {
      setHolidayText(txt);
      setModalHoliday(true);
  }

  function isDateValid(e, selectedDate) {
      var holiday = holidays.find(h => moment(h.holidayDate).format("YYYYMMDD") === moment(e).format("YYYYMMDD"))
      //return current.day() !== 0 && current.day() !== 6;
      if (holiday != null)
          return false
      else
          // แก้ให้จองวันเสาร์ return (e.day() !== 0 && e.day() !== 6 && e > (new Date()).setDate((new Date().getDate() - 1)))
          return (e.day() !== 0 && e > (new Date()).setDate((new Date().getDate() - 1)))
  }

  function renderDay(props, currentDate, selectedDate) {
      var holiday = holidays.find(h => moment(h.holidayDate).format("YYYYMMDD") === moment(currentDate).format("YYYYMMDD"))
      var hdt = (holiday != null) ? holiday.name : '';

      // Adds 0 to the days in the days view
      // แก้ให้จองวันเสาร์ได้ if ((props.className.indexOf('rdtDisabled') >= 0) && (currentDate.day() !== 0 && currentDate.day() !== 6 && currentDate > (new Date()).setDate((new Date().getDate() - 1)))) {
      if ((props.className.indexOf('rdtDisabled') >= 0) && (currentDate.day() !== 0  && currentDate > (new Date()).setDate((new Date().getDate() - 1)))) {    
        props.className += ' text-danger';
          //return <td {...props} style={{ textDecoration: 'Line-Through' }}>{currentDate.date()}</td>;
          return <td >
              <button
                  onClick={e => handleHoliday(hdt)}
                  class="btn btn-danger btn-icon btn-round" style={{ background: 'red' }}
              >
                  <span className="text-white" style={{ textDecoration: 'Line-Through' }}>{currentDate.date()}</span>
              </button>
          </td>; 
      }
      else {
          return <td {...props}>{currentDate.date()}</td>;
      }
  }



    const classes = useStyles();

    return (

        <div>

            <Grid>

                <Col xs={12} sm={12} md={12}>

                    <Card>
                        <CardHeader color="primary">

                            <h4 className={classes.cardTitleWhite}>แบบฟอร์มจองห้องประชุม</h4>
                            <p className={classes.cardCategoryWhite}> กรุณาระบุรายละเอียด </p>

                        </CardHeader>

                        <CardBody>
                            
                            <Grid>
                                <Col xs={12} sm={12} md={12}>
                                      <TSText icon="far fa-edit" label="ชื่อเรื่องการประชุม" value={MeetingName} onChange={e => setMeetingName(e.target.value)} />
                                  </Col>
                                  
                                <Col xs={12} sm={4} md={4}>
                                  <Label>วันที่ประชุม</Label>
                                  <FormGroup
                                        style={{ padding: '0 0px', marginBottom: '10px' }}
                                        className={
                                            "input-lg" + (dateFocus ? " input-group-focus" : "")
                                        }
                                    >
                                        <i className="far fa-calendar-check fa-2x" style={{
                                            position: 'absolute',
                                            left: '30px',
                                            zIndex: 1,
                                          
                                        }}
                                        ></i>
                                          <Datetime
                                              value={moment(StartDatetime).isValid() ? moment(StartDatetime) : null}
                                              renderYear={function (props, year, selectedDate) { return <td {...props}>{year + 543}</td>; }}
                                              isValidDate={isDateValid}
                                              renderDay={renderDay}
                                              //onBeforeNavigate={(a, b, c) => handleNavigate(a, b, c)}
                                              //onNavigateForward={(dayAmt, unit) => handleCurrentDate(dayAmt, unit)}
                                              //onNavigateBack={(dayAmt, unit) => handleCurrentDate((-1 * dayAmt), unit)}
                                              inputProps={{
                                                  name: "StartDatetime", placeholder: "วันที่ประชุม", readOnly: 'readonly'
                                                  , style: {
                                                      fontSize: '1.2em', borderRadius: 0, paddingLeft: '50px', cursor: 'pointer', background: '#ffffff', color: '#000000'
                                                  }
                                              }}
                                              closeOnSelect={true}
                                              closeOnTab={true}
                                              dateFormat="D MMMM BBBB" timeFormat={false}
                                              //dateFormat="D MMMM BBBB" timeFormat="เวลา HH:mm น."
                                              //timeFormat={false}
                                              onFocus={() => setDateFocus(true)}
                                              onBlur={() => setDateFocus(false)}
                                              onChange={e => handleStartDate(e.format('YYYY-MM-DD'))}
                         
                                              
                                        />

                                        
                                    </FormGroup>
                                </Col>

                                <Col xs={12} sm={4} md={4}>
                                  <TSSelect2 label="เวลาเริ่มประชุม" options={ArrStartTime} value={StartTme} onChange={e => handleStartTime(e.value) } />
                                </Col>

                                <Col xs={12} sm={4} md={4}>
                                  <TSSelect2 label="เวลาสิ้นสุด" options={ArrStopTime} value={EndTime} onChange={e => setEndTime(e.value) } />
                                </Col>

                               
                            </Grid>

                            <Grid>
                              {/*                     
                               <Col xs={12} sm={4} md={4}>
                                    <TSSelect2 label="ประเภทการประชุม" options={arrMeetingType} value={MeetingTypeKey} onChange={e => setMeetingTypeKey(e.value) } />
                                </Col>
                                */}  
                                <Col xs={12} sm={4} md={4}>
                                    <TSSelect2 label="ห้องประชุม" options={ArrRoom} value={RoomKey} onChange={e => setRoomKey(e.value) } />
                                </Col> 
                                <Col xs={12} sm={4} md={4}>
                                    <TSSelect2 label="รูปแบบการจัดห้องประชุม" options={ArrRoomStyle} value={RoomStyleKey} onChange={e => setRoomStyleKey(e.value) } />
                                </Col>
                                <Col xs={12} sm={4} md={4}>
                                     <TSText maxLength="3" type="tel" icon={"fas fa-chair"} label="จำนวนผู้เข้าร่วม" value={RoomTotalSeat} onChange={e => setRoomTotalSeat(e.target.value)} />
                                </Col>

                                <Col xs={12} sm={12} md={12}>
                                    <TSSelectMultiple label="อุปกรณ์ภายในห้องประชุม" options={ArrAsset} value={AssetKey} onChange={e => /* setAssetKey([...AssetKey, e])*/ setAssetKey(e) } />
                                              {/* 
                                    <Select
                                      defaultValue={AssetKey}
                                      isMulti
                                      name="colors"
                                      options={ArrAsset}
                                      className="basic-multi-select"
                                      classNamePrefix="select"
                                      onChange={e => setAssetKey([...AssetKey, e])  } 
                                    />
                                    */}
                                </Col>
                            </Grid>



                            <Grid>
                            <Col xs={12} sm={12} md={12}>
                                  <div className="textarea-container" style={{ padding: 0 }}>
                                        <Label for="Address">รายละเอียด </Label>  
                                            {/*(อ้างอิงจากที่อยู่ตอนลงทะเบียน, สามารถแก้ไขที่อยู่จัดส่งได้)*/}
                                        <Input
                                            id="MeetingDescription"
                                            cols="80"
                                            name="MeetingDescription"
                                            placeholder="รายละเอียด"
                                            rows="4"
                                            type="textarea"
                                            className="custom"
                                            style={{ fontSize: '1.2em', maxHeight: '150px' }}
                                            value={MeetingDescription}
                                            onChange={e => setMeetingDescription(e.target.value) }
                                            ></Input>
                                    </div>
                                </Col>


                            </Grid>
                            
                            {/*              
                            <Grid>
                                <Col xs={12} sm={6} md={6}>
                                    <TSSelect2 label="ประเภทหน่วยงาน" options={ArrTeamGroupType} value={TeamGroupTypeKey} onChange={e => handleTeamGroup(e.value) } />
                                </Col>
                                <Col xs={12} sm={6} md={6}>
                                  <TSSelect2 label="หน่วยงาน/คณะกรรมการ" options={ArrTeamGroup} value={TeamGroupKey} onChange={e => setTeamGroupKey(e.value) } />
                                </Col>
                            </Grid>
                            */}

                            <Grid> 
                             
                              <Col xs={12} sm={6} md={6}>
                                <TSText maxLength="10" type="tel" icon="fas fa-mobile-alt" label="หมายเลขโทรศัพท์" value={ContactPhone} onChange={e => setContactPhone(e.target.value)} />
                             </Col>

                             {(location.state != null && location.state != '' && location.state.meetingID != null && location.state.meetingID != '') ? 

                                  <Col xs={12} sm={6} md={6}>
                                    <div>ผู้จอง {CreatorName} {CreateDatetime != "" ? moment(CreateDatetime).format('DD MMM BB HH:mm').toString():""}</div>
                                    
                                    {EditerName != "" ?
                                    <div>แก้ไขล่าสุด {EditerName} {LastEditDatetime != "" ? moment(LastEditDatetime).format('DD MMM BB HH:mm').toString():""}</div>
                                    : <></>
                                    }

                                    {CancelerName != "" ?
                                    <div>ยกเลิกโดย {CancelerName} {CancelerName != "" ? moment(CancelDatetime).format('DD MMM BB HH:mm').toString():""}</div>
                                    : <></>
                                    }
                                </Col>
                             :
                                <Col xs={12} sm={6} md={6}></Col>
                             }
                            </Grid>
                            
                            <Grid>
                              <Col xs={12} sm={12} md={12}>  
                              
                              </Col>
                            </Grid>


                      </CardBody>
                      <CardFooter>
                          <Collapse isOpen={isOpen}>

                          </Collapse>
                            {/* Confirm */}
                            <Modal toggle={() => setModal(false)} isOpen={modal}>
                                <div className="modal-header justify-content-center">
                                    <div>
                                        <i
                                            className={icon}
                                            style={{ color: "blue", fontSize: "2em" }}
                                        ></i>
                                    </div>
                                </div>
                                <ModalBody>
                                    <p
                                        style={{
                                            textAlign: "center", fontSize: "1.8em"
                                        }}
                                    >
                                        {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                                            ? "ยืนยันการบันทึกข้อมูล"
                                            : "กำลังตรวจสอบข้อมูล"}
                                    </p>
                                    <p> </p>
                                </ModalBody>
                                <div className="modal-footer">

                                    <Button
                                        color="success"
                                        type="button"
                                        onClick={handleConfirm}
                                        disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                                    >
                                        <i className={"fa fa-thumbs-up"} style={{ fontSize: "1.8em", padding: "0 5px 5px 0" }}></i>
                                        <h4>ยืนยัน</h4>
                                    </Button>

                                    <Button
                                        color="danger"
                                        type="button"
                                        onClick={() => { setIcon("far fa-question-circle"); setModal(false); }}
                                    >
                                        <i className={"fa fa-thumbs-down"} style={{ fontSize: "1.8em", padding: "0 5px 5px 0" }}></i>
                                        <h4>ยกเลิก</h4>
                                    </Button>


                                </div>
                            </Modal>
                            {/* Cancel */}
                            <Modal toggle={() => setModalCancel(false)} isOpen={modalCancel}>
                                <div className="modal-header justify-content-center">
                                    <div>
                                        <i
                                            className={icon}
                                            style={{ color: "red", fontSize: "2em" }}
                                        ></i>
                                    </div>
                                </div>
                                <ModalBody>
                                    <p
                                        style={{
                                            textAlign: "center", fontSize: "1.8em"
                                        }}
                                    >
                                        {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                                            ? "ยืนยันยกเลิกการประชุม"
                                            : "กำลังตรวจสอบข้อมูล"}
                                    </p>
                                    <p> </p>
                                </ModalBody>
                                <div className="modal-footer">

                                    <Button
                                        color="success"
                                        type="button"
                                        onClick={handleCancel}
                                        disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                                    >
                                        <i className={"fa fa-thumbs-up"} style={{ fontSize: "1.8em", padding: "0 5px 5px 0" }}></i>
                                        <h4>ยืนยัน</h4>
                                    </Button>

                                    <Button
                                        color="danger"
                                        type="button"
                                        onClick={() => { setIcon("far fa-question-circle"); setModalCancel(false); }}
                                    >
                                        <i className={"fa fa-thumbs-down"} style={{ fontSize: "1.8em", padding: "0 5px 5px 0" }}></i>
                                        <h4>ปฏิเสธ</h4>
                                    </Button>


                                </div>
                            </Modal>

                         {/* Success */}
                         <Modal toggle={GotoEdit} isOpen={modal2}>
                            <div className="modal-header justify-content-center">
                              <div>
                                <i
                                  className={"fas fa-check"}
                                  style={{ color: "green", fontSize: "4em" }}
                                ></i>
                              </div>
                            </div>
                            <ModalBody>
                              <p
                                style={{
                                  textAlign: "center", fontSize: "1.8em"
                                }}
                              >
                               บันทึกข้อมูลสำเร็จ

                              </p>
                              <p> </p>
                            </ModalBody>
                            <div className="modal-footer">
                              <Button
                                color="info"
                                type="button"
                                onClick={GotoEdit}
                              >
                                <i className={"fa fa-thumbs-up"} style={{ fontSize: "1.8em", padding:"0 5px 5px 0" }}></i>
                                <h4>ตกลง</h4>
                              </Button>

                             
                            </div>
                          </Modal>           

                          {/* Error */}
                          <Modal toggle={() => setModalError(false)} isOpen={modalError}>
                            <div className="modal-header justify-content-center">
                              <div>
                                <i
                                  className="fa fa-times"
                                  style={{ color: "red", fontSize: "2em" }}
                                ></i>
                              </div>
                            </div>
                            <ModalBody>
                              <p>ไม่สามารถบันทึกข้อมูลได้</p>
                              <div>{errMsg}</div>
                            </ModalBody>
                            <div className="modal-footer justify-content-center">
                              <Button
                                color="primary"
                                type="button"
                                onClick={() => setModalError(false)}
                              >
                                <h4>ตกลง</h4>
                              </Button>
                            </div>
                          </Modal>


                      </CardFooter>
                    </Card>
                </Col>

                <Col xs={12} sm={12} md={12}>
                    <Card>
                          <CardHeader color="primary">

                              <h4 className={classes.cardTitleWhite}>ผู้เข้าร่วมประชุม</h4>
                              <p className={classes.cardCategoryWhite}>  </p>

                          </CardHeader>
                          <CardBody>                          
                              <Grid>
                                  <Col xs={12} sm={12} md={12}>
                                  <TSUser value={Attendee} isMultiple={true} onChange={e => { handleAttendee(e) } } />
                                  </Col>
                              </Grid>
                        </CardBody>
                        <CardFooter>
                            <Collapse isOpen={isOpen}>

                            </Collapse>
                            {/* Confirm */}
                        </CardFooter>
                    </Card>
                </Col>



                <Col xs={12} sm={12} md={12}>
                    <Card>
                          <CardHeader color="primary">

                              <h4 className={classes.cardTitleWhite}>บันทึกข้อมูล</h4>
                              <p className={classes.cardCategoryWhite}>  </p>

                          </CardHeader>
                          <CardBody>                          
                            <Grid>
                              
                              {(location.state != null && location.state != '' && location.state.meetingID != null && location.state.meetingID != '') ? 
                              <Col xs={12} sm={12} md={5} style={{ height: "48px" }}>
                                  <Button color="warning" onClick={handleSubmit} fullWidth>
                                    <i className={"fa fa-edit"}  style={{ fontSize: "1.8em", padding:"0 5px 5px 0" }} ></i>
                                    <h4>แก้ไข</h4>
                                  </Button>
                              </Col>
                              :
                              <Col xs={12} sm={12} md={5} style={{ height: "48px" }}>
                                <Button color="info" onClick={handleSubmit} fullWidth>
                                  <i className={"fa fa-save"}  style={{ fontSize: "1.8em", padding:"0 5px 5px 0" }} ></i>
                                  <h4>บันทึก</h4>
                                </Button>
                              </Col>
                              }

                                <Col xs={12} sm={12} md={2} >
                                  <>&nbsp;</>             
                                </Col>

                                <Col xs={12} sm={12} md={5} style={{ height: "48px" }}>
                                <Button color="danger" onClick = {() => { setModalCancel(true); }} fullWidth>
                                  <i className={"fa fa-ban"}  style={{ fontSize: "1.8em", padding:"0 5px 5px 0" }} ></i>
                                              <h4>ยกเลิก</h4>
                                  </Button>
                                </Col>
                            </Grid>
                            <Grid><Col>&nbsp;</Col></Grid>
                      
                        </CardBody>
                    </Card>
                </Col>


            </Grid>
        </div>
    );
}
export default Request;